import axiosInstance from '@/utils/api.js'

var state = {
  allRoutes: []
}

var getters = {
  ALL_ROUTES: (state) => {
    return state.allRoutes
  }
}

var mutations = {
  SET_ALL_ROUTES: (state, payload) => {
    state.allRoutes = payload
  }
}

var actions = {
  GET_ALL_ROUTES: async (context, payload) => {
    let result = await axiosInstance.get('/routes')
    if (result.status === 200) {
      context.commit('SET_ALL_ROUTES', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/routes.js